/*
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import Label from "../../../components/label";
import InstantSwitchLogo from "../../../assets/images/instant_extra_logo.png";
import appRoutes from "../../../routes/appRoutes";
import { connect } from "react-redux";
import Modal from "../../../components/customModal";
import {
  addConsultNoteStep2ApiRoute,
  changeOnlineAssessmentStatusAPI,
  getOrderHistoryAPI,
  instantSwitchMedicareConsultCostAPI,
  submitOnlineAssessmentAPI
} from "../../../apiRoutes";
import MakeAPICall from "../../../apiCalls/common";
import Loader from "../../../components/loader";
import Button from "../../../components/button";
import ICButton from "../../../components/button";
import ViewAssessment from "../../../containers/InstantSwitch/ViewAssessment/viewAssessment";
import { setOnlineAssessmentStatus } from "../../../reduxStore/actions/commonAction";

// containers
import Prescription from "../../../containers/InstantSwitch/Prescription/Prescription";
import PrescriptionTypeSelectionForm
  from "../../../containers/InstantSwitch/ViewAssessment/prescriptionTypeSelectionForm";

import {
  deleteDrugInfo,
  deleteNoteAttachment,
  removeAssessmentData,
  saveDrugInfo,
  saveNoteAttachment
} from "../../../reduxStore/actions/auth";
import { IS_ASSESSMENT_TYPES, ORDER_HISTORY_FILTERS } from "../../../constants/helperConstants";

class AssessmentViewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: props.auth,
      currentStep: 1, // TODO: change to step 1 as default
      assessmentId: props.match.params && props.match.params.id ? props.match.params.id : null,
      // Todo set these to the new PDF once sent through
      patientAttachedPDF: "", // pdf attachment id for sending email to patient
      assessmentData: null,
      apiCall: null,
      apiLoading: true,
      isSuccessModalOpen: false,
      followUpInDays: "",
      isPrescriptionFormVisible: false,
      selectedType: [], // out of 4 options 1 is needed
      additionalNoteForConsultNote: "", // for consult notes
      additionalNoteForPatient: "", // this one will go with email
      medicareCostId: "", // doctor selected medicare consult cost id - if the current consult is medicare,
      medicareConsultCosts: [], // if accepted assessment is billed by medicare then show this dropdown and it's mendatory
      selectedMedicareDuration: "", // we will store _id of medicare consult cost for instant switch and will send in api if it's a medicare assessment
      showRejectAssessmentConfirmationModal: false, // reject online assessment confirmation modal
      isPamphletRequired: false, // enable or disable submit button on last step
      prescriptionTypeSelectionFormData: {}
    };
  };

  componentDidMount() {
    console.log("---------- ", this.props);
    this.setState({
      apiLoading: true
    });
    this.getAssessmentDetails();
  }

  addSelectedType(types) {
    this.setState({
      selectedType: [...types]
    });
  }

  validate() {
    return this.state.currentStep === 2;
  }

  increaseCurrentStep() {
    this.setState({
      currentStep: this.state.currentStep + 1
    });
  }

  decreaseCurrentStep() {
    this.setState({
      currentStep: this.state.currentStep - 1
    });
  }

  // we store prescription urls and drug information in redux data
  addReduxDataForAssessment(assessmentData) {
    if (assessmentData.treatmentPlan && assessmentData.treatmentPlan.drug) {
      assessmentData.treatmentPlan.drug.map((drugInfo, index) => {
        let dataToSave = {
          "name": drugInfo.name,
          "strength": drugInfo.strength,
          "formType": drugInfo.formType,
          "quantity": drugInfo.quantity,
          "repeats": drugInfo.repeats,
          "regulation24": drugInfo.regulation24,
          "otherPrescriptionDetails": drugInfo.otherPrescriptionDetails ? drugInfo.otherPrescriptionDetails : ""
        };

        if (this.state.assessmentData.assessmentType === "Medicinal Cannabis") {
          dataToSave = Object.assign(dataToSave, {
            "category": drugInfo.category,
            "indication": drugInfo.indication,
            "miniIntervalRepeats": drugInfo.miniIntervalRepeats
          });
        }

        this.props.saveDrugInfo(dataToSave);
      });
    }
  }

  async getAssessmentDetails() {
    const param = {
      assessmentId: this.state.assessmentId
    };
    let apiCallParam = {
      reqType: "GET",
      reqURL: getOrderHistoryAPI,
      dataObj: {},
      params: param,
      headers: {},
      successCallback: res => {
        console.log("Got the assessment details: ", res);
        const data = res.data.data.orderHistoryData[0];
        this.setState({
          apiLoading: false,
          assessmentData: res.data.data.orderHistoryData[0]
        });
        this.addReduxDataForAssessment(res.data.data.orderHistoryData[0]);
        if (res.data.data.orderHistoryData[0].isBulkBilled) {
          this.getConsultCostDetails();
        }

        if (data.assessmentType === "Medicinal Cannabis" && this.props.constants.instantSwitchAttachedMCPDFs && this.props.constants.instantSwitchAttachedMCPDFs.length) {
          this.setState({
            isPamphletRequired: true
          });
        } else if (this.props.constants.instantSwitchAttachedPDFs && this.props.constants.instantSwitchAttachedPDFs.length) {
          this.setState({
            isPamphletRequired: true
          });
        }
      },
      failureCallback: err => {
        console.log("Something went wrong. Please try again ", err);
        this.setState({
          apiLoading: false
        });
      }
    };
    this.setState({
      apiCall: apiCallParam
    });
  }

  async getConsultCostDetails() {
    this.setState({
      apiLoading: true
    });
    let apiCallParam = {
      reqType: "GET",
      reqURL: instantSwitchMedicareConsultCostAPI,
      dataObj: {},
      params: {},
      headers: {},
      successCallback: res => {
        console.log("Got the medicare consult cost details: ", res.data.data.consultDetailData);
        let medicareCost = [];
        res.data.data.consultDetailData.map((value, index) => {
          medicareCost.push({
            _id: value._id,
            val: value.description
          });
        });
        this.setState({
          medicareConsultCosts: medicareCost,
          apiLoading: false
        });
      },
      failureCallback: err => {
        console.log("Something went wrong. Please try again ", err);
        this.setState({
          apiLoading: false
        });
      }
    };
    this.setState({
      apiCall: apiCallParam
    });
  }

  async goBack() {
    await this.props.setOnlineAssessmentStatus(false);
    await this.props.removeAssessmentData();
    this.props.history.goBack();
  }

  async goToViewAssessment() {
    const assessmentId = this.state.assessmentId;
    await this.props.setOnlineAssessmentStatus(false);
    await this.props.removeAssessmentData();
    this.props.history.push(appRoutes.instantSwitchViewCompletedAssessment + "/" + assessmentId, { _id: assessmentId });
  }

  openAttachment(attachment) {
    window.open(attachment.url, "_blank");
  }

  deleteAttachment(attachment, index) {
    console.log("assesment*****", attachment);
    this.props.deleteNoteAttachment(attachment);
    if (this.props.prescriptionDrugs && this.props.prescriptionDrugs[attachment.selectedTypes]) {
      let allDrugInfo = this.props.prescriptionDrugs[attachment.selectedTypes]["drugs"];
      const filterDeletedDrug = allDrugInfo.filter(
        item => ((item.url !== attachment.url))
      );
      let drugInfoToSave = this.props.prescriptionDrugs;
      drugInfoToSave[attachment.selectedTypes]["drugs"] = filterDeletedDrug;
      this.props.deleteDrugInfo(drugInfoToSave);
    }
  }

  handleSubmitAssessment() {
    this.setState({
      apiLoading: true
    });
    console.log("Now submitting assessment");

    let noteText = "Patient understands and consents to the nature and limitations of a telemedicine consultation\nPatient ID, DOB and address confirmed\n\nFind attached online assessment and recommended treatment plan";
    if (this.state.additionalNoteForConsultNote) {
      noteText = noteText + "\n\n" + this.state.additionalNoteForConsultNote;
    }

    let formData = new FormData();
    formData.append("patientId", this.state.assessmentData.patientId._id);
    formData.append("note", noteText);
    formData.append("templates", JSON.stringify(this.props.attachments));

    if (this.state.assessmentData.assessmentType === IS_ASSESSMENT_TYPES.MEDICINAL_CANNABIS) {
      formData.append("isInstantSwitchMC", true);
    } else if (this.state.assessmentData.assessmentType === IS_ASSESSMENT_TYPES.SMOKING_CESSATION) {
      formData.append("isInstantSwitch", true);
    }

    formData.append("onlineAssessmentId", this.state.assessmentData._id);

    let apiCallParam = {
      reqType: "POST",
      reqURL: addConsultNoteStep2ApiRoute,
      dataObj: formData,
      params: {},
      headers: {},
      successCallback: res => {
        console.log("COnsult note added successfully: ", res);
        this.sendAssessmentEmailToPatient(res.data.data._id);
        // this.setState({
        //     apiLoading: false
        // });
      },
      failureCallback: err => {
        console.log("Somethign went wrong during consult note step 2: ", err);
        this.setState({
          apiLoading: false
        });
      }
    };
    this.setState({
      apiCall: apiCallParam
    });
  }

  sendAssessmentEmailToPatient(consultNoteId) {
    console.log("Now sending assessment email to patient");
    this.setState({
      apiLoading: true
    });

    // if (this.state.assessmentData.isBulkBilled && !this.state.selectedMedicareDuration || !this.state.patientAttachedPDF) {
    //     return;
    // }

    if (this.state.assessmentData.isBulkBilled && !this.state.selectedMedicareDuration) {
      this.setState({
        apiLoading: false
      });
      alert("Bulk-Billed Not Allowed");
      return;
    }

    const formData = new FormData();
    formData.append("assessmentId", this.state.assessmentId);
    formData.append("types", JSON.stringify(this.state.selectedType));
    formData.append("additionalNoteForEmail", this.state.additionalNoteForPatient);
    formData.append("drugs", JSON.stringify(this.props.prescriptionDrugs));
    formData.append("medicareCostId", this.state.selectedMedicareDuration);
    formData.append("consultNoteId", consultNoteId);
    formData.append("patientAttachedPDF", this.state.patientAttachedPDF);
    formData.append("followUpInDays", this.state.followUpInDays);

    let apiCallParam = {
      reqType: "POST",
      reqURL: submitOnlineAssessmentAPI,
      // dataObj: dataToSend,
      dataObj: formData,
      params: {},
      headers: {},
      successCallback: res => {
        this.props.removeAssessmentData();
        console.log("Assessment Submitted Successfully");
        this.setState({
          isSuccessModalOpen: true,
          apiLoading: false
        });
        // this.goBack();
      },
      failureCallback: err => {
        console.log("Error while submitting Assessment Submitted Successfully : ", err);
        this.setState({
          apiLoading: false
        });
      }
    };
    this.setState({
      apiCall: apiCallParam
    });
  }

  toggleRejectConfirmationModal() {
    this.setState({
      showRejectAssessmentConfirmationModal: !this.state.showRejectAssessmentConfirmationModal
    });
  }

  rejectOnlineAssessment() {
    this.setState({
      apiLoading: true
    });

    this.toggleRejectConfirmationModal();
    const dataToSend = {
      assessmentId: this.state.assessmentId,
      assessmentStatus: ORDER_HISTORY_FILTERS.REJECTED
    };

    let apiCallParam = {
      reqType: "POST",
      reqURL: changeOnlineAssessmentStatusAPI,
      dataObj: dataToSend,
      params: {},
      headers: {},
      successCallback: res => {
        this.props.removeAssessmentData();
        console.log("Assessment Submitted Successfully");
        this.setState({
          apiLoading: false
        });
        this.goBack();
      },
      failureCallback: err => {
        console.log("Error while submitting Assessment Submitted Successfully : ", err);
        this.setState({
          apiLoading: false
        });
      }
    };
    this.setState({
      apiCall: apiCallParam
    });
  }

  render() {
    return (
      <div className="row rounded p-3 assessment-page">
        <div className="col-sm-12 p-3">
          <p onClick={() => this.goBack()}
             className="p-0 m-0 insta-link-orange font-15 text-decoration-none cursor-pointer">
            <i className="fas fa-arrow-left" />{" "}
            <img src={InstantSwitchLogo} alt="is_logo" className="instant-switch-back-button-logo ml-2" />
          </p>
        </div>

        <div className="w-100 border" />
        {
          this.state.assessmentData && (
            <Fragment>
              <div className="col-sm-6 p-0">
                {/* Left Side Patient Details */}
                <ViewAssessment auth={this.state.auth} assessmentData={this.state.assessmentData} />
                <ICButton title="Reject Online Assessment" className="ml-3 red"
                          clickEvent={() => this.toggleRejectConfirmationModal()} />
                {/*Placeholder here to prevent medical info on hover from going out of view*/}
                <div style={{ height: 200 }} />
              </div>
              <div className="col-sm-6 mt-4">
                <div className="card pt-3 pb-3">
                  <div className="row p-0 m-0">
                    {
                      this.state.currentStep === 1 && (
                        <Fragment>
                          <div className="col-sm-12">
                            {/* First Type Selections like Over the counter / Prescribed Medications / Vaping | e-Cigarate / Combination Therapy */}
                            <PrescriptionTypeSelectionForm assessmentData={this.state.assessmentData}
                                                           selectedType={this.state.selectedType}
                                                           setFormState={(data) => {
                                                             this.setState({ ...data });
                                                           }}
                                                           formState={this.state}
                                                           addSelectedType={(types) => this.addSelectedType(types)} />
                          </div>
                        </Fragment>
                      )
                    }
                    {
                      this.state.currentStep === 2 &&  (
                        <>
                          <div className="col-sm-12 pt-2 pb-4">
                            <p onClick={() => this.decreaseCurrentStep()}
                               className="p-0 m-0 insta-link-orange font-15 text-decoration-none cursor-pointer pl-3">
                              <i className="fas fa-arrow-left" />{" "}
                              <span className="ml-1 pt-1 back-btn-text">Back</span>
                            </p>
                            <Prescription selectedType={this.state.selectedType}
                                          assessmentData={this.state.assessmentData}
                                          togglePrescriptionComponent={() => this.decreaseCurrentStep()} />
                          </div>
                          {/* List of Prescriptions - Show Attached Prescriptions from the redux store */}
                        </>
                      )
                    }

                    {!!this.state.selectedType.length && this.state.currentStep !== 2 &&
                      <div className="mt-4 col-sm-12 text-center"><Button type="button"
                                                                          title="Add Prescription"
                                                                          clickEvent={() => this.setState({ currentStep: 2 })} />
                      </div>
                    }
                    {
                      (this.state.currentStep !== 2 && !!this.props.attachments.length) ? (
                        <Fragment>
                          <div className="container-fluid mt-3 mb-3">
                            <div className="row p-0 m-0">
                              <div className="col-sm-6 pt-1">
                                <Label title="Attached Prescriptions" className="secondary-font w-100" />
                              </div>

                              <div className="col-sm-12 mt-1 pb-4">
                                {
                                  this.props.attachments.map((attachment, index) => {
                                    return (
                                      <div className="prescription-attachments cursor-pointer mr-2 mt-2"
                                           key={index}>
                                        <div className="pdf-text cursor-pointer"
                                             onClick={() => this.openAttachment(attachment)}>
                                          <Label title="PDF" className="cursor-pointer" />
                                        </div>
                                        <div className="attachment-type-name cursor-pointer"
                                             onClick={() => this.openAttachment(attachment)}>
                                          <Label
                                            title={`ePrescription.pdf ${attachment.drugName ? " - " + attachment.drugName : ""}`}
                                            className="cursor-pointer ml-3" />
                                        </div>
                                        <div className="delete-icon"
                                             onClick={() => this.deleteAttachment(attachment, index)}>
                                          <i className="fas fa-times" />
                                        </div>
                                      </div>
                                    );
                                  })
                                }
                              </div>
                              <div className="col-sm-12">
                                <div className="col-sm-12 mt-4 pt-2 text-center">
                                  <ICButton className="ml-3" title="Submit Treatment Plan"
                                            clickEvent={() => {
                                              this.handleSubmitAssessment();
                                            }}
                                            disabled={!this.state.selectedType.length} />
                                </div>
                              </div>
                            </div>
                          </div>
                        </Fragment>
                      ) : (
                        ""
                      )
                    }
                  </div>
                </div>
              </div>
            </Fragment>
          )
        }

        {/* Success API Modal  */}
        <Modal
          openModal={this.state.isSuccessModalOpen}
          modalBodyContent={
            <p className="text-center mb-0">
              Assessment Submitted Successfully
            </p>
          }
          okayText="Save"
          cancelText="Okay"
          title="Instant Consult"
          useOneButton={true}
          cancelEvent={() => {
            // this.goBack();
            this.goToViewAssessment();
          }}
        />

        <Modal
          openModal={this.state.showRejectAssessmentConfirmationModal}
          modalBodyContent={
            <p className="text-center mb-0">
              Are you sure you want to reject this online assessment?
            </p>
          }
          okayText="Reject"
          cancelText="Close"
          title="Instant Consult"
          useOneButton={false}
          cancelEvent={() => {
            this.toggleRejectConfirmationModal();
          }}
          okayEvent={() => {
            this.rejectOnlineAssessment();
          }}
        />

        <MakeAPICall apiParam={this.state.apiCall} />
        <Loader loading={this.state.apiLoading} />
      </div>
    );
  }
}

// export default AssessmentViewPage;

// get the store
const mapStateToProps = props => ({
  auth: props.auth.user,
  constants: props.auth.user.appConstant,
  attachments: props.auth.attachments ? props.auth.attachments : [],
  prescriptionDrugs: props.auth.prescriptionDrugs ? props.auth.prescriptionDrugs : []
});

const mapDispatchToProps = dispatch => ({
  deleteNoteAttachment: data => dispatch(deleteNoteAttachment(data)),
  setOnlineAssessmentStatus: data => dispatch(setOnlineAssessmentStatus(data)),
  deleteDrugInfo: data => dispatch(deleteDrugInfo(data)),
  saveNoteAttachment: data => dispatch(saveNoteAttachment(data)),
  saveDrugInfo: data => dispatch(saveDrugInfo(data)),
  removeAssessmentData: () => dispatch(removeAssessmentData())
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AssessmentViewPage));
